import { type Payment } from './payment';

export type PaymentNonComplianceReason = 'SEPA_TRANSFER_AMOUNT_LIMIT_REACHED';

export type PaymentCompliantResult = {
  isCompliant: true;
  payment: Payment;
};

export type PaymentNonCompliantResult = {
  isCompliant: false;
  reason: PaymentNonComplianceReason[];
  payment: Payment;
  compliantPaymentsSuggestion: Payment[];
};

export type PaymentComplianceResult =
  | PaymentCompliantResult
  | PaymentNonCompliantResult;

export const isEveryPaymentCompliant = (
  paymentComplianceResults: PaymentComplianceResult[],
): boolean =>
  !paymentComplianceResults.some(
    (paymentCompliance) => paymentCompliance.isCompliant === false,
  );
